import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "constants/colors";

interface Props {
  isVisible: boolean;
  message: string;
}

const Toast = ({ isVisible, message }: Props) => {
  const [showView, setShowView] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShowView(true);
    } else {
      const timer = setTimeout(() => setShowView(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  return (
    <>
      {showView && (
        <StyledToastWrapper $isVisible={isVisible}>
          <StyledToastBoxView>
            <StyledMessage>{message}</StyledMessage>
          </StyledToastBoxView>
        </StyledToastWrapper>
      )}
    </>
  );
};
export default Toast;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const StyledToastWrapper = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  left: 20px;
  right: 20px;
  bottom: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  pointer-events: none;
  animation: ${({ $isVisible }) => ($isVisible ? fadeIn : fadeOut)} 0.3s
    ease-out;
`;

const StyledToastBoxView = styled.div`
  padding: 16px;
  max-width: 360px;
  width: 100%;
  background-color: rgba(17, 17, 17, 0.9);
  border-radius: 16px;
`;

const StyledMessage = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${colors.white};
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
